<template>
	<div>
		<div class="box">
			<ul>
				<li 
					v-for='(item,index) in statusList' 
					:class="item.class"
					:key='item.val'
					@click="navTo(index)">
						<img src="@/assets/img/suc.jpg" class="suc" v-if="item.class=='green'">
						<span>{{item.val}}</span>
				</li>
			</ul>
			<div style="clear: both;"></div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				statusList:[
					{
						val:'1.选择影片，场次',
						class:'green',
						path:'/mvInfo'
					},
					{
						val:'2.选座',
						class:'red',
						path:'/selSeat'
					},
					{
						val:'3.确认订单',
						class:'gray',
						path:'/ticConfirm'
					},
					{
						val:'4.确认支付',
						class:'gray',
						path:'/payOrder'
					}
				],
			}
		},
		props:['curStatus','orderId'],
		created:function(){
			var statusList = this.statusList;
			var curStatus = this.curStatus;
			for(var i=0;i<statusList.length;i++){
				if(i<curStatus){
					statusList[i].class = 'green'
				}
				else if(i==curStatus){
					statusList[i].class = 'red'
				}
				else{
					statusList[i].class = 'gray'
				}
			}
		},
		methods:{
			navTo:function(index){
				var curPath = this.$route.path;
				var curPathIndex = '';
				var tarPathIndex = '';
				var tarPath = this.statusList[index].path;
				var statusList = this.statusList;
				for(var i=0;i<statusList.length;i++){
					if(curPathIndex && tarPathIndex){
						break;
					}
					if( curPath == statusList[i].path ){
						curPathIndex = i;
					}
					if( tarPath == statusList[i].path ){
						tarPathIndex = i;
					}
				}
				//只支持后退
				if( curPathIndex > tarPathIndex ){
					var backCount = tarPathIndex - curPathIndex;
					this.$router.go(backCount)
				}
			},
			
		}
	}
</script>

<style scoped src='@/assets/css/buyTicStatus.css'>
</style>
